import { cellAt, dayLabel } from '@apps/web/features/coverage/model/cell_model';
import {
    CELL_STATE_LABELS,
    type CoverageRow,
    DAY_PARTS,
    EMPLOYMENT_TYPE_LABELS,
    type WorkWeekStartDay,
} from '@apps/web/features/coverage/model/coverage_types';

const ATTRIBUTE_COLUMNS = [
    'Name',
    'Office',
    'City',
    'State',
    'ZIP',
    'Employment type',
    'Active',
    'Tags',
    'Has availability data',
];

/**
 * Flatten the filtered grid into a fixed export schema: attribute
 * columns plus 28 day x day-part columns holding state words, so the
 * file pivots cleanly in a spreadsheet regardless of on-screen column
 * visibility.
 */
export function buildExportTable(
    rows: ReadonlyArray<CoverageRow>,
    workWeekStartDay: WorkWeekStartDay,
): { columns: Array<string>; rows: Array<Array<string>> } {
    const cellColumns: Array<string> = [];
    for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
        for (const part of DAY_PARTS) {
            cellColumns.push(
                `${dayLabel(dayIndex, workWeekStartDay)} ${part.label}`,
            );
        }
    }

    const exportRows = rows.map((row) => {
        const values = [
            row.name,
            row.office_name ?? '',
            row.city ?? '',
            row.state ?? '',
            row.postal_code ?? '',
            row.employment_type
                ? (EMPLOYMENT_TYPE_LABELS[row.employment_type] ??
                  row.employment_type)
                : '',
            row.is_active ? 'yes' : 'no',
            row.tags.join('; '),
            row.has_availability_data ? 'yes' : 'no',
        ];
        for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
            for (const part of DAY_PARTS) {
                values.push(
                    CELL_STATE_LABELS[cellAt(row, dayIndex, part.key).state],
                );
            }
        }
        return values;
    });

    return {
        columns: [...ATTRIBUTE_COLUMNS, ...cellColumns],
        rows: exportRows,
    };
}
